export default __webpack_public_path__ + "static/media/curiousjr.d5afb8b7.svg";